import api from '@/api/itemType'

const state = {
    item: null,
    items: [],
}

const mutations = {
    set_item(state, payload) {
        state.item = payload
    },
    set_items(state, payload) {
        state.items = payload
    },
}

const actions = {
    create(context, payload) {
        return api
            .create(payload)
            .then(results => {
                console.log('createdResults', results)
            })
            .catch(err => {
                throw err
            })
    },
    fetchById(context, id) {
        return api
            .fetchById(id)
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('fetch item', data)
                    context.commit('set_item', data)
                }
            )
            .catch(err => {
                throw err
            })
    },

    fetchAll(context) {
        return api
            .fetchAll()
            .then(
                ({
                    data: {
                        success: { data },
                    },
                }) => {
                    console.log('fetchall', data)
                    context.commit('set_items', data)
                }
            )
            .catch(err => {
                throw err
            })
    },

    update(context, payload) {
        console.log('update', payload)
        return api
            .update(payload.id, payload)
            .then(results => {
                console.log('updateResults', results)
            })
            .catch(err => {
                throw err
            })
    },
    delete(context, id) {
        return api
            .delete(id)
            .then(() => {
                let index = state.items.findIndex(x => x.id == id)
                context.state.items.splice(index, 1)
            })
            .catch(err => {
                throw err
            })
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
